export enum SearchMode {
  EntityNameAndTitle = 'entityNameAndTitle',
  Summary = 'summary',
  ThreatActorName = 'threatActorName',
  ArticleUrlReference = 'articleUrlReference',
  ArticleContent = 'articleContent',
}

export const SearchInDescriptor = Object.freeze({
  [SearchMode.EntityNameAndTitle]: 'Entity Name and Titles',
  [SearchMode.Summary]: 'Summary',
  [SearchMode.ThreatActorName]: 'Threat Actor Name',
  [SearchMode.ArticleUrlReference]: 'Article URL - Reference',
  [SearchMode.ArticleContent]: 'Article Content',
});
